<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Seçilen dosyalar eklensinmi?</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
      İptal
    </button>
    <button type="button" class="btn btn-warning" (click)="confirmAction()" rippleEffect>
      Onayla
    </button>
  </div>
  